import Jwt from 'framework/helpers/jwt'
import ConfigHelper from 'framework/helpers/config'

const JWT_HASHING_ALGOS = {
    HS256: 'HS256',
}

/**
 * Function for generating JWT (JSON Web Token) for OTT
 * @param {Object} config - object with configuration for JWT
 * @param {String} config.accountId - id of account for sub claim of JWT
 * @param {Number} [config.serverTimeStampOffset = 0] - Ufinity server timestamp offset to get proper iat
 * @param {String} config.accountType - type of account for subType claim of JWT
 * @param {String} config.privateKey - RSA private key for signing a JWT
 * @param {String} config.iss - issuer of JWT for iss claim of JWT
 * @return {String} generated JWT
 */
export const generateJwtForOtt = ({
    serverTimeStampOffset = 0,
    accountId,
    accountType,
    privateKey,
    iss,
}) => {
    const { enableTimeAdjustmentFromServer = true } =
        ConfigHelper.getInstance().getConfig('ufinity')
    const header = { alg: JWT_HASHING_ALGOS.HS256, typ: 'JWT' }
    const payload = {
        iss,
        iat:
            (enableTimeAdjustmentFromServer &&
                serverTimeStampOffset &&
                getIat(serverTimeStampOffset)) ||
            // In order to avoid that device date is in the future for few ms, remove 2 secondes
            Math.floor(Date.now() / 1000) - 2,
        sub: accountId,
        subType: accountType,
    }
    const jwt = new Jwt(header, payload, privateKey).generateJwt()

    return jwt
}

/**
 * Calculate iat JWT claim
 *
 * Needed to calculate proper `issued at` claim for JWT in cases when user set device's time
 * manually. Fixes `invalid JWT claims - iat` error
 *
 * @param {Number} [serverTimeStampOffset = 0] an offset between Ufinity server and user's local time
 * @returns {Number} `issued at` claim for JWT in seconds
 */
const getIat = (serverTimeStampOffset = 0) => {
    const currentDate = Date.now()
    return Math.floor((currentDate - serverTimeStampOffset) / 1000)
}
